import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import lightbulb_svg from '../../../assets/img/SVG_icons/Left/main_control/lightbulb.svg';
import { img } from '@phi/components';
import { open_in_new_tab } from '@phi/util/window';
import LightbulbTooltip from './LightbulbTooltip';

export const LightbulbIcon = lightbulb_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Suggest a feature';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                open_in_new_tab('https://phi.nolt.io/');
        },
    },

    render() {
        return h(BarButton, {
            id: 'lightbulb-button',
            tippy: 'top',
            onClick: this.onClick,
            active: false,
            disabled: this.disabled,
            selected: this.state.tut_stage === 14,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(lightbulb_svg, this.alt),
            tooltip: LightbulbTooltip,
        });
    },
});
